import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker, CalendarIcon } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AxiosInstance from "../../../utils/AxiosInstance";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import AdvanceHistoryModal from "./AdvanceHistory";
import AdvanceModal from "./AddAdvance";
import DateConverter from "@heartinz/date_and_time_processor";
import jsPDF from "jspdf";
import InterRegular from "../estimation/font/Inter_24pt-Regular-normal";
import InterBold from "../estimation/font/Inter_24pt-Bold-normal";
import autoTable from "jspdf-autotable";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { useNetwork } from "../../../context/NetworkContext";
import Messages from "../../../constants/Messages";
import EditCutomer from "../customer/EditCustomer";
import AddCustomer from "../customer/AddCustomer";
import TaskModal from "./AddTask";
import DeleteModal from "../../../constants/DeleteModal";
import { CircularProgress } from "@mui/material";
import uRLs from "../../../utils/baseUtils";
import SpecificationsModal from "./AddSpecification";
import { useContextApi } from "../../../context/ContextApi";
import CancelConfirmation from "./DeleteConfirmation";
import SearchInput from "../../../constants/SearchInput";
import { Browser2InchSimpleReceipt } from "../../../utils/print/Thermal_M1InchBrowser";
import { Generate2InchSimpleReceipt } from "../../../utils/print/Thermal_M1InchGenerator";
import axios from "axios";
import { getOS } from "../../../utils/getOs";
import ProductSearchList from "../../../constants/ProductSearchList";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { AddIcon, CheckIcon, CheckLgIcon, CloseIcon, DeleteIcon, EditIcon, HourglassSplitIcon, PrinterIcon, UndoIcon } from "../../../constants/Icons";

const EditJobcard = ({
  editData,
  onClose,
  onFieldUpdate,
  titleSuggest,
  attributeSuggest,
  onJobcardUpdate,
  handleJobcardFieldUpdate,
  isActive,
  setTitleSuggest,
  jobcardTitleSuggest,
}) => {
  const { isUser, updateSettings, settings } = useAuth();
  const showAlert = useShowAlert();
  const serverTime = GetServerLiveTime();
  const [billing, setBilling] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [advanceModalOpen, setAdvanceModalOpen] = useState(false);
  const [jobcardId, setJobcardId] = useState(null);
  const [titleLocked, setTitleLocked] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);
  const flatpickrRef = useRef(null);
  const customerWrapperRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(editData?.customer);
  const [isCustomerData, setCustomerData] = useState(null);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionRefs = useRef([]);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const { checkNetwork } = useNetwork();
  const [errors, setErrors] = useState({});
  const { customerGroups, blockedPermissions, permission, storeSettings } =
    usePermission();
  const os = getOS();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);
  const [numberSuggest, setNumberSuggest] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [localTitleSuggest, setLocalTitleSuggest] = useState([]);
  const [print, setPrint] = useState(false);
  const [attributesopen, setAttributesOpen] = useState(false);
  const [selectedSize, setSelectedSize] = useState("A4"); // default 2-inch receipt
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const TitleRef = useRef();
  const [jobNo, setJobNo] = useState(editData?.jobNo || "");
  const [formData, setFormData] = useState({
    mediaFile: editData?.mediaFile || null,
    title: editData?.title || "",
    description: editData?.description || "",
    dueDate: editData?.dueDate ? new Date(editData?.dueDate) : null,
    status: editData?.status || "PENDING",
    priority: editData?.priority || "MEDIUM",
    estimatedCost: editData?.estimatedCost || "",
    advancePaid: editData?.totalAdvancePaid || 0,
  });

  const [filteredTitleSuggestions, setFilteredTitleSuggestions] = useState([]);
  const [showTitlePopup, setShowTitlePopup] = useState(false);
  const [highlightedTitleIndex, setHighlightedTitleIndex] = useState(-1);

  const titleSuggestionRefs = useRef([]);
  const titleListRef = useRef(null);

  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [tasks, setTasks] = useState(editData?.task || []);
  const [editDataState, setEditDataState] = useState(editData);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [advanceHistory, setAdvanceHistory] = useState([]);
  const [loadingAdvanceHistory, setLoadingAdvanceHistory] = useState(false);
  const [localEditData, setLocalEditData] = useState(editData);
  const { useEscapeKey } = useContextApi();
  const [totalAdvancePaid, setTotalAdvancePaid] = useState(
    Number(editData?.totalAdvancePaid) || 0,
  );
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [pendingStatus, setPendingStatus] = useState("");

  useEscapeKey(onClose);
  const handleAttributesUpdate = (updatedAttributes) => {
    //  update local view
    setLocalEditData((prev) => ({
      ...prev,
      attributes: updatedAttributes,
    }));

    //  update modal edit data state (used in the modal)
    setEditDataState((prev) => ({
      ...prev,
      attributes: updatedAttributes,
    }));
  };

  const handlePrintService = async (pdfBase64, printerName) => {
    console.log("handleprintservice");
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("inside success");
      setPrint(false);
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPrint(false);
    }
  };

  const handleCheckPrintService = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await axios.get("http://127.0.0.1:9164/ping", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = response.data;
      if (result && storeSettings?.printSystemSettings?.printThrough) {
        setBilling(true);
      }
    } catch (error) {
      return null;
    }
  };

  const handlePrintSystem = async (pdfBase64, printerName) => {
    console.log(
      os,
      printerName,
      storeSettings?.printSystemSettings?.printThrough,
    );
    if (
      os === "Windows" &&
      storeSettings?.printSystemSettings?.printThrough &&
      printerName
    ) {
      console.log("inside if");
      return await handlePrintService(pdfBase64, printerName);
    } else {
      console.log("inside if");
      setBilling(false);
    }
    return false;
  };

  const ensureJobcard = async () => {
    let id = jobcardId;

    if (!id) {
      const res = await AxiosInstance.get("module/jobcard/create/jobno");

      id = res.data?.results?._id;

      setJobcardId(id);
      setJobNo(res.data?.results?.jobNo);
    }

    return id;
  };

  const getJobcardId = async () => {
    let id = editData?._id || jobcardId;

    if (!id) {
      id = await ensureJobcard();
    }

    return id;
  };

  const handleBlurUpdate = async (field, value) => {
    try {
      let id = editData?._id || jobcardId;

      // If no id (new jobcard) create one
      if (!id) {
        id = await ensureJobcard();
      }

      if (value !== formData[field]) {
        onFieldUpdate(id, field, value);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTitleSave = async (e) => {
    const value = e.target.value.trim();
    if (!value) return;

    try {
      let id = editData?._id || jobcardId;

      if (!id) {
        id = await ensureJobcard();
      }

      await AxiosInstance.patch(`module/jobcard/add-or-update/${id}`, {
        title: value,
      });
    } catch (error) {
      handleError(error);
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };
  let cachedProfileImageBase64 = null;

  const generateJobCardPDF = async (data, timezone = "Asia/Kolkata") => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 8; // Cleaner, wider margins for a modern feel

    // --- 1. Top Modern Accent Line ---
    doc.setFillColor(30, 41, 59); // Sleek Slate Gray/Blue accent color
    doc.rect(0, 0, pageWidth, 4, "F");

    const headerX = margin;
    const headerY = 10;
    const headerWidth = pageWidth - margin * 2;

    // --- 2. Logo Handling ---
    const imagePath = uRLs.IMAGE_URL + "profile/" + settings?.saleProfileData?.image;
    let imgHeight = 0;
    let imgWidth = 0;

    if (settings?.saleProfileData?.image) {
        try {
            if (!cachedProfileImageBase64) {
                const response = await fetch(imagePath);
                const blob = await response.blob();
                cachedProfileImageBase64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            }

            const { width: naturalWidth, height: naturalHeight } =
                await loadImageDimensions(cachedProfileImageBase64);

            const maxWidth = 45;
            const maxHeight = 15;
            imgWidth = naturalWidth;
            imgHeight = naturalHeight;

            const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
            imgWidth *= ratio;
            imgHeight *= ratio;

            doc.addImage(cachedProfileImageBase64, "JPEG", headerX, headerY, imgWidth, imgHeight);
        } catch (err) {
            console.warn("Image failed to load:", err);
        }
    }

    // --- 3. Right-Aligned Company Profile ---
    const addressX = pageWidth - margin; 
    let addressY = headerY + 2;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(11);
    doc.setTextColor(30, 41, 59); // Deep Slate Primary
    const titleText = String(settings?.saleProfileData?.title || "").toUpperCase();
    doc.text(titleText, addressX, addressY, { align: "right" });
    addressY += 5;

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(100, 116, 139); // Muted slate gray for secondary info

    if (settings?.saleProfileData?.addressline1) {
        doc.text(settings.saleProfileData.addressline1, addressX, addressY, { align: "right" });
        addressY += 4;
    }
    if (settings?.saleProfileData?.addressline2) {
        doc.text(settings.saleProfileData.addressline2, addressX, addressY, { align: "right" });
        addressY += 4;
    }

    let combinedLine = [
        settings?.saleProfileData?.district,
        settings?.saleProfileData?.state,
        settings?.saleProfileData?.country,
    ].filter(Boolean).join(", ");

    if (settings?.saleProfileData?.pincode) combinedLine += ` - ${settings.saleProfileData.pincode}`;
    if (settings?.saleProfileData?.phone) combinedLine += ` | Ph: ${settings.saleProfileData.phone}`;

    if (combinedLine) {
        doc.text(combinedLine, addressX, addressY, { align: "right" });
        addressY += 4;
    }

    let emailCINLine = "";
    if (settings?.saleProfileData?.email) emailCINLine += settings.saleProfileData.email;
    if (settings?.saleProfileData?.cinnumber) {
        emailCINLine += emailCINLine ? ` | CIN: ${settings.saleProfileData.cinnumber}` : `CIN: ${settings.saleProfileData.cinnumber}`;
    }
    if (emailCINLine) {
        doc.text(emailCINLine, addressX, addressY, { align: "right" });
        addressY += 4;
    }

    let GSTFSSAILine = "";
    if (settings?.saleProfileData?.gstnumber) GSTFSSAILine += `GST: ${settings.saleProfileData.gstnumber}`;
    if (settings?.saleProfileData?.fssai) {
        GSTFSSAILine += GSTFSSAILine ? ` | FSSAI: ${settings.saleProfileData.fssai}` : `FSSAI: ${settings.saleProfileData.fssai}`;
    }
    if (GSTFSSAILine) {
        doc.text(GSTFSSAILine, addressX, addressY, { align: "right" });
        addressY += 4;
    }

    // --- 4. Main Document Title Banner ---
    let titleSectionY = Math.max(headerY + imgHeight + 8, addressY + 4);
    
    // Subtle horizontal divider line
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(0.5);
    doc.line(margin, titleSectionY, pageWidth - margin, titleSectionY);
    titleSectionY += 8;

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(16);
    doc.setTextColor(15, 23, 42);
    doc.text("JOB CARD", margin, titleSectionY);

    // --- 5. Clean Grid Layout: Customer & Job Information ---
    let infoY = titleSectionY + 8;
    const colWidth = (pageWidth - margin * 2) / 2;

    // Left Side Info List
    const leftItems = [
        { label: "Job No", value: data?.jobNo || "" },
        { label: "Due Date", value: data?.dueDate ? DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(data?.dueDate)).date : "" },
        { label: "Advance Paid", value: data?.totalAdvancePaid && Number(data.totalAdvancePaid) > 0 ? `₹${CurrencyConverter.toCurrency(data.totalAdvancePaid, "INR")}.00` : "₹0.00" },
        { label: "Status", value: data?.status ? data.status.toUpperCase() : "" },
        { label: "Priority", value: data?.priority ? data.priority.toUpperCase() : "" },
    ];

    doc.setFontSize(9);
    leftItems.forEach((item) => {
        doc.setFont("Inter-Bold", "bold");
        doc.setTextColor(71, 85, 105);
        doc.text(item.label, margin, infoY);

        doc.setFont("Inter-Regular", "normal");
        doc.setTextColor(15, 23, 42);
        // Emphasize the active Job No
        if (item.label === "Job No") doc.setFont("Inter-Bold", "bold"); 
        doc.text(`:  ${item.value}`, margin + 28, infoY);
        infoY += 5.5;
    });

    // Customer Info Placement directly below left items
    infoY += 2;
    const customerItems = [
        { label: "Client Name", value: data?.customer?.name },
        { label: "Phone", value: data?.customer?.phone },
    ].filter(item => item.value != null);

    customerItems.forEach((item) => {
        doc.setFont("Inter-Bold", "bold");
        doc.setTextColor(71, 85, 105);
        doc.text(item.label, margin, infoY);

        doc.setFont("Inter-Regular", "normal");
        doc.setTextColor(15, 23, 42);
        doc.text(`:  ${item.value}`, margin + 28, infoY);
        infoY += 5.5;
    });

    // Right Column — Specifications / Attributes
    let specY = titleSectionY + 8;
    const rightItems = data.attributes || [];

    if (rightItems.length > 0) {
        doc.setFont("Inter-Bold", "bold");
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59);
        doc.text("SPECIFICATIONS", margin + colWidth, specY);
        specY += 6;

        doc.setFontSize(9);
        rightItems.forEach((attr) => {
            doc.setFont("Inter-Bold", "bold");
            doc.setTextColor(71, 85, 105);
            doc.text(`${attr.key}`, margin + colWidth, specY);

            doc.setFont("Inter-Regular", "normal");
            doc.setTextColor(15, 23, 42);
            doc.text(`:  ${attr.value || ""}`, margin + colWidth + 28, specY);
            specY += 5.5;
        });
    }

    // Modern Table Spacing Calculation
    let y = Math.max(infoY, specY) + 8;

    // --- 6. Premium Designed AutoTable ---
    const checkbox = `/assets/images/unchecked.png`;
    const tickIcon = `/assets/images/check.png`;

      if (data.task && data.task.length > 0) {
      const filteredTasks = data.task.filter(
        (task) => task.status?.toLowerCase() !== "cancelled",
      );

      if (filteredTasks.length > 0) {
        // doc.setFont("Inter-Bold", "bold").setFontSize(10);
        // doc.text("Tasks", headerX + 5, y);
        y += 1;

        // Prepare table data (add empty column for icon)
        const taskData = filteredTasks.map((task, index) => [
          index + 1, // Sno only number
          `${task.title || ""}${
            task.description ? " - " + task.description : ""
          }`,
          task.amount != null
            ? `₹${CurrencyConverter.toCurrency(task.amount || 0, "INR")}`
            : "₹0",
          "", // Empty cell for icon column
        ]);

        autoTable(doc, {
          startY: y,
          head: [["Sno", "Description", "Amount", ""]], // last column header empty
          body: taskData,
          theme: "grid",
          margin: { left: margin, right: margin },
          headStyles: {
            fillColor: "#f4f4f6",
            textColor: "#292d51",
            fontStyle: "bold",
            font: "Inter-Bold",
            halign: "center",
            valign: "middle",
          },
          columnStyles: {
            0: { halign: "center", cellWidth: 10 ,valign: "middle"},
            1: { halign: "left",cellWidth: "auto",valign: "middle" },
            2: { halign: "center", cellWidth: 20,valign: "middle" },
            3: { halign: "center", cellWidth: 15,valign: "middle" }, // icon column
          },
          styles: {
            font: "Inter-Regular",
            fontStyle: "normal",
            fontSize: 9,
            halign: "left",
            cellPadding: 2,
            lineColor: [200, 200, 200],
            lineWidth: 0.2,
            textColor: "#041121",
          },
          didDrawCell: (dataCell) => {
            // Draw icon in the last column (index 3)
            if (
              dataCell.column.index === 3 &&
              dataCell.row.section === "body"
            ) {
              const task = filteredTasks[dataCell.row.index];
              const x = dataCell.cell.x + dataCell.cell.width / 2 - 3; // center align
              const y = dataCell.cell.y + dataCell.cell.height / 2 - 3;
              const size = 6;

              if (task.status?.toLowerCase() === "completed") {
                doc.addImage(tickIcon, "PNG", x, y, size, size);
              } else {
                doc.addImage(checkbox, "PNG", x, y, size, size);
              }
            }
          },
        });

        y = doc.lastAutoTable.finalY + 35;
      }
    }

    // --- 7. Clean, Minimal Footer ---
   
    
       if (storeSettings?.negobillBranding) {
       const footerY = pageHeight - 6; // 30pt from bottom for safe margin

        
        doc.setFontSize(8);
         doc.setFont("Inter-Regular", "normal");
        doc.setTextColor(0,0,0);
        
        const normPart = "Powered by ";
        const boldPart = "NegoBill.com";
        const totalW = doc.getTextWidth(normPart) + doc.getTextWidth(boldPart);
        
        let startX = (pageWidth - totalW) / 2;
        
         doc.setFont("Inter-Regular", "normal");
        doc.text(normPart, startX, footerY);
        startX += doc.getTextWidth(normPart);
        
        doc.setFont("Inter-Bold", "bold");
        doc.setTextColor(0,0,0);
        doc.text(boldPart, startX, footerY);
      }
 

    return doc;
};

  const generateSimpleReceipt = async (data, timezone = "Asia/Kolkata") => {
    // setPrint(true);
    const doc = new jsPDF({
      unit: "pt",
      format: [288, 1000],
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 18;

    // --- Helper: Page Break Check ---
    const checkPageBreak = (y, buffer = 20) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return 14;
      }
      return y;
    };

    // --- HEADER TITLE ---
    doc.setFont("Inter-Bold", "bold").setFontSize(16);
    doc.text("RECEIPT", pageWidth / 2, y, { align: "center" });
    y += 18;

    // --- STORE NAME ---
    doc.setFont("Inter-Regular", "normal").setFontSize(14);
    const wrappedStoreTitle = doc.splitTextToSize(
      settings?.saleProfileData?.title,
      pageWidth - 30,
    );
    wrappedStoreTitle.forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 16;
    });

    doc.setFontSize(9);
    if (settings?.saleProfileData?.phone) {
      doc.text(
        `Ph: ${settings?.saleProfileData?.phone || ""}`,
        pageWidth / 2,
        y,
        { align: "center" },
      );
      y += 16;
    }

    y += 16;
    doc.setFontSize(9);

    // --- JOB NO ---
    if (data?.jobNo) {
      doc.setFont("Inter-Bold", "bold");
      doc.text(`Job No:`, 10, y);
      doc.setFont("Inter-Regular", "normal");
      doc.text(String(data.jobNo), 50, y);
      y += 16;
    }

    // --- DATE & TIME ---
    let dateStr = "N/A";
    let timeStr = "N/A";
    if (data?.updatedAt) {
      const converted = DateConverter.convertToTimeZone(
        data.updatedAt,
        timezone,
      );
      const formatted = DateConverter.ISOToDisplayFormat(converted);
      dateStr = formatted.date || "-";
      timeStr = formatted.time || "-";
    }

    doc.setFont("Inter-Bold", "bold").setFontSize(10);
    doc.text("Date:", 10, y);
    doc.setFont("Inter-Regular", "normal");
    doc.text(`${dateStr} | ${timeStr}`, 45, y);
    y += 16;

    // --- ADVANCE PAID (moved here below date) ---
    if (data?.totalAdvancePaid && Number(data.totalAdvancePaid) > 0) {
      doc.setFont("Inter-Bold", "bold").setFontSize(11);
      doc.text("Advance Paid:", 10, y);
      doc.setFont("Inter-Bold", "bold");
      doc.text(
        `₹${CurrencyConverter.toCurrency(
          data.totalAdvancePaid || 0,
          "INR",
        )}.00`,
        90,
        y,
      );
      y += 16;
    }

    // --- LINE ---
    doc.setLineDash([1, 1], 0);
    doc.line(8, y, pageWidth - 8, y);
    doc.setLineDash([]);
    y += 16;

    // --- CUSTOMER DETAILS HEADING (only if name or phone exists) ---
    if (data?.customer?.name || data?.customer?.phone) {
      doc.setFont("Inter-Bold", "bold").setFontSize(11);
      doc.text("Customer Details", 10, y);
      y += 14;

      // --- CUSTOMER NAME ---
      if (data.customer?.name) {
        doc.setFont("Inter-Bold", "bold").setFontSize(10);
        doc.text("Name:", 10, y);
        doc.setFont("Inter-Regular", "normal");
        doc.text(String(data?.customer?.name), 45, y);
        y += 14;
      }

      // --- CUSTOMER PHONE ---
      if (data.customer?.phone) {
        doc.setFont("Inter-Bold", "bold").setFontSize(10);
        doc.text("Phone:", 10, y);
        doc.setFont("Inter-Regular", "normal");
        doc.text(String(data.customer.phone), 45, y);
        y += 14;
      }

      // --- DOTTED LINE AFTER CUSTOMER DETAILS ---
      doc.setLineDash([1, 1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 18;
    }

    // --- JOB TITLE (task title) ---
    if (data?.title) {
      doc.setFont("Inter-Bold", "bold").setFontSize(10);
      doc.text("Title:", 10, y);
      doc.setFont("Inter-Regular", "normal");
      const wrappedTitle = doc.splitTextToSize(
        String(data.title),
        pageWidth - 20,
      );
      wrappedTitle.forEach((line) => {
        doc.text(line, 40, y);
        y += 14;
      });
      y += 6;
    }
    // --- TASK LIST ---
    // if (Array.isArray(data?.task) && data.task.length > 0) {
    //   const validTasks = data.task.filter(
    //     (item) => item?.status !== "CANCELLED"
    //   );

    //   if (validTasks.length > 0) {
    //     // doc.setFont("Inter-Bold", "bold").setFontSize(11);
    //     // doc.text("Tasks", 10, y);
    //     // y += 14;

    //     // --- HEADER ---
    //     doc.setFont("Inter-Bold", "bold").setFontSize(10);
    //     doc.text("Title", 10, y);
    //     doc.text("Amount", pageWidth - 10, y, { align: "right" });
    //     y += 12;

    //     doc.setLineDash([1, 1], 0);
    //     doc.line(8, y, pageWidth - 8, y);
    //     doc.setLineDash([]);
    //     y += 10;

    //     // --- ITEMS ---
    //     validTasks.forEach((item) => {
    //       y = checkPageBreak(y);

    //       const title = String(item?.title || "");
    //       const amount = `₹${CurrencyConverter.toCurrency(item?.amount || 0, "INR")}`;

    //       const wrappedTitle = doc.splitTextToSize(title, pageWidth - 80);

    //       wrappedTitle.forEach((line, index) => {
    //         doc.setFont("Inter-Regular", "normal").setFontSize(10);

    //         doc.text(line, 10, y+2);

    //         if (index === 0) {
    //           doc.text(amount, pageWidth - 10, y+2, { align: "right" });
    //         }

    //         y += 12;
    //       });
    //     });

    //     // y += 10;

    //     // --- LINE ---
    //     doc.setLineDash([1, 1], 0);
    //     doc.line(8, y, pageWidth - 8, y);
    //     doc.setLineDash([]);
    //     y += 16;
    //   }
    // }
    if (data?.dueDate) {
      doc.setFont("Inter-Bold", "bold");
      doc.text("Due Date:", 10, y);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        `${
          DateConverter.ISOToDisplayFormat(
            DateConverter.convertToTimeZone(data?.dueDate),
          ).date
        }`,
        59,
        y,
      );
      y += 6;
    }
    y += 6;
    // --- LINE ---
    doc.setLineDash([1, 1], 0);
    doc.line(8, y, pageWidth - 8, y);
    doc.setLineDash([]);
    y += 20;
    y = checkPageBreak(y);

    // --- THANK YOU & BRAND ---
    doc.setFont("Inter-Regular", "normal").setFontSize(10);
    doc.text("Thank you!", pageWidth / 2, y, { align: "center" });
    y += 15;
    doc.text("** Visit Again **", pageWidth / 2, y, { align: "center" });
    if (storeSettings?.negobillBranding) {
      y += 15;
      doc.text("Powered by", pageWidth / 2, y, { align: "center" });
      y += 15;

      // --- Website (bold NegoBill) ---
      const sitePrefix = "www.";
      const siteBold = "NegoBill";
      const siteSuffix = ".com";
      const prefixWidth = doc.getTextWidth(sitePrefix);
      const boldWidth = doc.getTextWidth(siteBold);
      const suffixWidth = doc.getTextWidth(siteSuffix);
      const totalWidth = prefixWidth + boldWidth + suffixWidth;
      const startX = (pageWidth - totalWidth) / 2;

      doc.setFont("Inter-Regular", "normal");
      doc.text(sitePrefix, startX, y);
      doc.setFont("Inter-Bold", "bold");
      doc.text(siteBold, startX + prefixWidth, y);
      doc.setFont("Inter-Regular", "normal");
      doc.text(siteSuffix, startX + prefixWidth + boldWidth, y);
    }
    // setPrint(false);
    return doc;
  };

  const generateJobCardHalfA4PDF = async (data, timezone = "Asia/Kolkata") => {
    // setPrint(true);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth(); // ≈ 842 pt
    const pageHeight = doc.internal.pageSize.getHeight(); // ≈ 595 pt

    const padding = 20;
    const headerHeight = 60;

    const headerX = padding;
    const headerY = padding;
    const headerWidth = pageWidth - padding * 2;

    // --- JOB CARD Title (Left Side) ---
    doc.setFont("Inter-Bold", "bold").setFontSize(20).setTextColor(71, 69, 67);
    const titleX = headerX;
    const titleY = headerY + 25;
    doc.text("JOB CARD", titleX, titleY);

    // --- Company Info (Right Side, aligned top with header) ---
    let infoX = pageWidth - padding; // right-aligned
    let infoY = headerY; // start from top

    doc.setFont("Inter-Bold", "bold").setFontSize(11).setTextColor(60);
    const titleText = String(settings?.saleProfileData?.title || "");
    doc.text(titleText, infoX, infoY, { align: "right" });
    infoY += 12;

    doc.setFont("Inter-Regular", "normal").setFontSize(9);

    const addrLines = [
      settings?.saleProfileData?.addressline1,
      settings?.saleProfileData?.addressline2,
    ].filter(Boolean);

    addrLines.forEach((line) => {
      doc.text(line, infoX, infoY, { align: "right" });
      infoY += 10;
    });

    let combinedLine = [
      settings?.saleProfileData?.district,
      settings?.saleProfileData?.state,
      settings?.saleProfileData?.country,
    ]
      .filter(Boolean)
      .join(", ");

    if (settings?.saleProfileData?.pincode)
      combinedLine += ` - ${settings.saleProfileData.pincode}`;
    if (settings?.saleProfileData?.phone)
      combinedLine += ` | Ph: ${settings.saleProfileData.phone}`;
    if (combinedLine) {
      doc.text(combinedLine, infoX, infoY, { align: "right" });
      infoY += 10;
    }

    let emailCIN = [];
    if (settings?.saleProfileData?.email)
      emailCIN.push(settings.saleProfileData.email);
    if (settings?.saleProfileData?.cinnumber)
      emailCIN.push(`CIN: ${settings.saleProfileData.cinnumber}`);
    if (emailCIN.length) {
      doc.text(emailCIN.join(" | "), infoX, infoY, { align: "right" });
      infoY += 10;
    }

    let gstFssai = [];
    if (settings?.saleProfileData?.gstnumber)
      gstFssai.push(settings.saleProfileData.gstnumber);
    if (settings?.saleProfileData?.fssai)
      gstFssai.push(`FSSAI: ${settings.saleProfileData.fssai}`);
    if (gstFssai.length) {
      doc.text(gstFssai.join(" | "), infoX, infoY, { align: "right" });
    }

    // --- Job Info & Specifications Section ---
    let infoYz = headerY + headerHeight + 10;
    let leftX = headerX;
    let rightX = pageWidth / 2 + 20;

    doc.setFontSize(9).setTextColor(40);

    const leftItems = [
      { label: "Job No", value: `: ${data?.jobNo || "-"}` },
      {
        label: "Due Date",
        value: `: ${
          data?.dueDate
            ? DateConverter.ISOToDisplayFormat(
                DateConverter.convertToTimeZone(data?.dueDate),
              ).date
            : ""
        }`,
      },
      {
        label: "Advance Paid",
        value:
          data?.totalAdvancePaid && Number(data.totalAdvancePaid) > 0
            ? `: ₹${CurrencyConverter.toCurrency(data.totalAdvancePaid, "INR")}`
            : ": ",
      },
      {
        label: "Status",
        value: `: ${data?.status ? data.status.toLowerCase() : ""}`,
      },
      {
        label: "Priority",
        value: `: ${data?.priority ? data.priority.toLowerCase() : ""}`,
      },
    ];

    const rightItems = data.attributes || [];

    let leftY = infoYz;
    leftItems.forEach((item) => {
      doc.setFont("Inter-Bold", "bold").text(item.label, leftX, leftY);
      doc
        .setFont("Inter-Regular", "normal")
        .text(String(item.value), leftX + 60, leftY);
      leftY += 14;
    });

    let rightY = infoYz;
    if (rightItems.length > 0) {
      doc.setFont("Inter-Bold", "bold").setFontSize(10);
      doc.text("Specifications", rightX, rightY);
      rightY += 12;

      rightItems.forEach((attr) => {
        const key = attr.key || "";
        const value = attr.value || "";
        doc
          .setFont("Inter-Bold", "bold")
          .setFontSize(9)
          .text(`${key}:`, rightX, rightY);
        doc
          .setFont("Inter-Regular", "normal")
          .text(
            String(value),
            rightX + doc.getTextWidth(`${key}: `) + 2,
            rightY,
          );
        rightY += 12;
      });
    }

    // --- Customer Info ---
    let customerY = Math.max(leftY, rightY) + 2;
    const customerItems = [
      { label: "Customer Name :", value: data?.customer?.name },
      { label: "Phone :", value: data?.customer?.phone },
    ].filter((item) => item.value != null);

    customerItems.forEach((item) => {
      doc.setFont("Inter-Bold", "bold").text(item.label, leftX, customerY);
      doc
        .setFont("Inter-Regular", "normal")
        .text(String(item.value), leftX + 80, customerY);
      customerY += 12;
    });

    // --- Tasks Table ---
    let y = customerY + 5;
    const checkbox = `/assets/images/unchecked.png`;
    const tickIcon = `/assets/images/check.png`;

    if (data.task && data.task.length > 0) {
      const filteredTasks = data.task.filter(
        (task) => task.status?.toLowerCase() !== "cancelled",
      );

      if (filteredTasks.length > 0) {
        const taskData = filteredTasks.map((task, index) => [
          index + 1,
          `${task.title || ""}${
            task.description ? " - " + task.description : ""
          }`,
          task.amount != null
            ? `₹${CurrencyConverter.toCurrency(task.amount || 0, "INR")}`
            : "₹0",
          "",
        ]);

        autoTable(doc, {
          startY: y,
          head: [["Sno", "Description", "Amount", ""]],
          body: taskData,
          theme: "grid",
          headStyles: {
            fillColor: "#f4f4f6",
            textColor: "#292d51",
            font: "Inter-Bold",
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
          },
          columnStyles: {
            0: { halign: "center", cellWidth: 30 },
            1: { halign: "left" },
            2: { halign: "center", cellWidth: 60 },
            3: { halign: "center", cellWidth: 35 },
          },
          styles: {
            font: "Inter-Regular",
            fontStyle: "normal",
            fontSize: 9,
            halign: "left",
            lineColor: [200, 200, 200],
            textColor: "#041121",
            cellPadding: 3,
            lineWidth: 0.3,
          },
          didDrawCell: (dataCell) => {
            if (
              dataCell.column.index === 3 &&
              dataCell.row.section === "body"
            ) {
              const task = filteredTasks[dataCell.row.index];
              const x = dataCell.cell.x + dataCell.cell.width / 2 - 4;
              const y = dataCell.cell.y + dataCell.cell.height / 2 - 4;
              const size = 10;

              if (task.status?.toLowerCase() === "completed") {
                doc.addImage(tickIcon, "PNG", x, y, size, size);
              } else {
                doc.addImage(checkbox, "PNG", x, y, size, size);
              }
            }
          },
        });

        y = doc.lastAutoTable.finalY + 20;
      }
    }

    // --- Footer (centered at bottom) ---
    const footerY = pageHeight - 40;
    doc.setFont("Inter-Regular", "normal").setFontSize(10);
    doc.text("Thank you!", pageWidth / 2, footerY, { align: "center" });
    doc.text("** Visit Again **", pageWidth / 2, footerY + 12, {
      align: "center",
    });
    if (storeSettings?.negobillBranding) {
      doc.text("Powered by NegoBill.com", pageWidth / 2, footerY + 24, {
        align: "center",
      });
    }
    setPrint(false);
    return doc;
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const handlePrint = async (type, jobcardId) => {
    try {
      if (!checkNetwork()) return;
      if (!jobcardId) return;
      setPrint(true);
      const response = await AxiosInstance.get(`/module/jobcard/${jobcardId}`);
      const jobcardData = response.data.results;

      let doc;
      let result;
      if (type === "receipt") {
        {
          billing
            ? (doc = await Generate2InchSimpleReceipt(
                jobcardData,
                storeSettings,
                settings,
              ))
            : (doc = await Browser2InchSimpleReceipt(
                jobcardData,
                storeSettings,
                settings,
              ));
        }
        const pdfBase64 = doc.output("datauristring").split(",")[1];
        result = await handlePrintSystem(
          pdfBase64,
          storeSettings?.printSystemSettings?.printerName,
        );
      } else if (type === "jobcard-a4") {
        doc = await generateJobCardPDF(jobcardData);
      } else if (type === "jobcard-half") {
        doc = await generateJobCardHalfA4PDF(jobcardData);
      } else {
        setPrint(false);
        return;
      }
      console.log(result, storeSettings?.printSystemSettings?.printThrough);
      if (!storeSettings?.printSystemSettings?.printThrough || !result) {
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);

        // Create hidden iframe for printing
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.src = url;

        document.body.appendChild(iframe);
        iframe.onload = () => {
          setPrint(false);
          setTimeout(() => {
            if (window.bootstrap && window.bootstrap.Dropdown) {
              const dropdownElementList = [].slice.call(
                document.querySelectorAll(".dropdown-toggle"),
              );
              dropdownElementList.map(function (dropdownToggleEl) {
                return new window.bootstrap.Dropdown(dropdownToggleEl);
              });
            }
          }, 100);
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }, 500);
        };
      }
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
  };

  // const fetchTemplateList = async () => {
  //   try {
  //     const res = await AxiosInstance.get("module/jobcard/template/list");

  //     if (res?.data?.status) {
  //       setTemplateList(res.data.results || []);
  //     }
  //   } catch (error) {
  //     console.error("Template fetch error", error);
  //   }
  // };

  // const handleTemplateAttach = async (templateId) => {
  //   if (!templateId) {
  //     setSelectedTemplate("");
  //     return;
  //   }

  //   try {
  //     const id = editData?._id;

  //     if (!id) {
  //       showAlert("warning", "Jobcard not created yet");
  //       return;
  //     }

  //     const response = await AxiosInstance.patch(
  //       `module/jobcard/${id}/template/${templateId}`,
  //     );

  //     if (response?.data?.status) {
  //       const attributes = response?.data?.results?.attributes || [];

  //       setSelectedTemplate(templateId);

  //       // Update specifications UI
  //       setLocalEditData((prev) => ({
  //         ...prev,
  //         attributes: attributes,
  //       }));

  //       showAlert("success", "Template applied successfully");
  //     }
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  const handleTaskStatusChange = async (task, newStatus) => {
    try {
      if (!task?._id) return;

      // 1️⃣ Update task status via API
      const response = await AxiosInstance.patch(
        `module/jobcard/task/${editData._id}`,
        {
          taskid: task._id,
          status: newStatus,
        },
      );

      const updatedJobcard = response?.data?.results;
      if (!updatedJobcard) return;

      // 2️⃣ Update tasks locally (excluding cancelled)
      setTasks(updatedJobcard.task.filter((t) => t.status !== "CANCELLED"));
      setFormData((prev) => ({
        ...prev,
        status: updatedJobcard.status, // update the dropdown
        // estimatedCost: updatedJobcard.estimatedCost,
      }));

      setEditDataState((prev) => ({
        ...prev,
        status: updatedJobcard.status,
      }));
      if (typeof onJobcardUpdate === "function") {
        onJobcardUpdate(updatedJobcard);
      }
      showAlert("success", `Jobcard status updated`);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const fetchAdvanceHistory = async () => {
    if (!editData?._id) return;
    try {
      setLoadingAdvanceHistory(true);
      const response = await AxiosInstance.get(
        `/module/jobcard/history/${editData._id}`,
      );
      const history = response.data?.results || [];
      setAdvanceHistory(history);
    } catch (error) {
      console.error("Error fetching advance history:", error);
    } finally {
      setLoadingAdvanceHistory(false);
    }
  };

  const handleCustomerModalOpen = () => {
    // setSelectedCustomer(null);
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleResetCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "website",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }
    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    setLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = { ...updatedData, customerid: updatedData._id };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );

      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);

      setCustomerData(response.data.results);
      setSelectedCustomer(response.data.results);
      const id = await getJobcardId();
      await onFieldUpdate(id, "customerid", response.data.results);
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    const value = e.target.value.toUpperCase();

    if (value === "CANCELLED") {
      setPendingStatus(value);
      setShowCancelConfirm(true);
      return; // wait for confirmation before updating
    }

    handleChange("status", value);
    handleBlurUpdate("status", value);
  };

  const confirmCancellation = () => {
    handleChange("status", pendingStatus);
    handleBlurUpdate("status", pendingStatus);
    setShowCancelConfirm(false);
    onClose();
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleCustomerAdd = async (newData) => {
    setLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      handleResetCustomer();
      handleSelectCustomer(response.data.results);
      const id = await getJobcardId();
      await onFieldUpdate(id, "customerid", response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerSearch = (term) => {
    setCustomerSearchTerm(term);
    if (term.trim() === "") {
      setCustomerSuggestions([]);
      setCustomerData(null);
      return;
    }
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        setIsCustomerLoading(true);
        if (!checkNetwork()) return;
        controllerRef.current = new AbortController();
        const response = await AxiosInstance.get(
          `module/customer/search?searchtxt=${encodeURIComponent(term.trim())}`,
          { signal: controllerRef.current.signal },
        );
        setCustomerSuggestions(response.data.results || []);
        const data = { phone: "", name: "" };
        if (/^\d+$/.test(term.trim())) {
          data.phone = term.trim();
        } else {
          data.name = term.trim();
        }
        setCustomerData(data);
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setIsCustomerLoading(false);
      }
    }, 200);
  };

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/customer/details/${customer._id}`,
      );
      const fullCustomer = response.data.results;
      setSelectedCustomer(fullCustomer.customerData);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
      const id = await getJobcardId();

      await onFieldUpdate(id, "customerid", fullCustomer.customerData);
    } catch (error) {
      handleError(error, showAlert);
    }

    // Store customer inside active cart
    // updateActiveCart((cart) => ({
    //   ...cart,
    //   customer,
    // }));
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        // amountRef.current[0]?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer?.name?.toLowerCase() === trimmedSearch?.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        openEditModal(isEditData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  const handleDeleteTask = async () => {
    if (!isDeleteData?._id || !editDataState?._id) return;
    setBtnLoading(true);
    try {
      const response = await AxiosInstance.delete(
        `module/jobcard/${editDataState._id}/task/${isDeleteData._id}`,
        { data: { remarks: "Task deleted" } },
      );

      const updatedJobcard = response?.data?.results;

      if (response?.data?.status && updatedJobcard) {
        // Update local form/edit states
        setFormData((prev) => ({
          ...prev,
          status: updatedJobcard.status,
        }));

        setEditDataState((prev) => ({
          ...prev,
          estimatedCost: updatedJobcard.estimatedCost,
          task: updatedJobcard.task || [],
          status: updatedJobcard.status,
        }));
        if (typeof onJobcardUpdate === "function") {
          onJobcardUpdate(updatedJobcard);
        }
        setTasks((prev) => prev.filter((t) => t._id !== isDeleteData._id));
        showAlert("success", "Task deleted successfully");
      } else {
        showAlert(
          "warning",
          response?.data?.message || "Failed to delete task",
        );
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnLoading(false);
      setDeleteModalOpen(false);
      setDeleteData(null);
    }
  };

  const options = [
    {
      value: "LOW",
      label: "Low",
      icon: <span className="badge bg-success rounded-pill">!</span>,
    },
    {
      value: "MEDIUM",
      label: "Medium",
      icon: <span className="badge bg-warning rounded-pill">!!</span>,
    },
    {
      value: "HIGH",
      label: "High",
      icon: <span className="badge bg-danger rounded-pill">!!!</span>,
    },
  ];

  const selectedOption =
    options.find((opt) => opt.value === formData.priority) ||
    options.find((opt) => opt.value === "MEDIUM");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isActive) return;

    const timer = setTimeout(() => {
      TitleRef.current?.focus();
      // TitleRef.current?.select();
    }, 150); // small delay for modal render

    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        customerWrapperRef.current &&
        !customerWrapperRef.current.contains(event.target)
      ) {
        setShowCustomerDropdown(false);
        setHighlightedIndex(-1);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowTitlePopup(false);
        setHighlightedTitleIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // handleCustomerNumbersuggestion();
    handleCheckPrintService();
  }, []);

  useEffect(() => {
    if (editData?._id !== editDataState?._id) {
      setEditDataState(editData);
      setTasks(editData?.task || []);
      setLocalEditData(editData);
    }
  }, [editData]);

  useEffect(() => {
    if (editData?.title) {
      setTitleLocked(true);
    }
  }, [editData]);

  // useEffect(() => {
  //   fetchTemplateList();
  // }, []);

  return (
    <div className="modal-overlay" style={{ zIndex: 1010 }}>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="JObCardModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered ">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title me-2">
                JobCard -{" "}
                <span
                  className="badge rounded-pill"
                  style={{
                    background: "#ffab1d",
                    color: "#000",
                    border: "none",
                  }}
                >
                  {jobNo || editData?.jobNo}
                </span>
              </h5>
              <div className="d-flex align-items-center gap-2">
                <p className="small mb-0 text-right">
                  <b className="tm_primary_color">Created By:</b>{" "}
                  {editData?.createdByUserId?.staffName
                    ? editData.createdByUserId.staffName
                        .charAt(0)
                        .toUpperCase() +
                      editData.createdByUserId.staffName.slice(1)
                    : "Admin"}
                </p>

                {""}
                <p className="small mb-0 text-right">
                  <b className="tm_primary_color">Created On:</b>{" "}
                  {editData?.createdAt
                    ? DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          editData?.createdAt,
                          "Asia/Kolkata",
                        ),
                      ).date
                    : "-"}{" "}
                  {editData?.createdAt
                    ? DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          editData?.createdAt,
                          isUser.timezone,
                        ),
                      ).time
                    : "-"}
                </p>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
            </div>

            {/* Modal Body */}
            <div className="modal-body bg-light ">
              <div
                className="row g-2"
                // style={{
                //   height: "calc(100vh - 220px)",
                //   overflow: "hidden",
                // }}
              >
                <div
                  className="col-md-8"
                  style={{ maxHeight: "100%", overflowY: "auto" }}
                >
                  <div className="mb-4" ref={wrapperRef}>
                    <label className="form-label">
                      Title <span className="text-danger">*</span>
                    </label>

                    <div className="col-lg-6 position-relative">
                      <input
                        ref={TitleRef}
                        type="text"
                        className={`form-control ${errors.title ? "is-invalid" : ""}`}
                        value={formData.title || ""}
                        placeholder="Enter title"
                        disabled={false}
                        onBlur={handleTitleSave}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            title: value,
                          }));

                          if (value.trim().length > 0) {
                            const filtered = (jobcardTitleSuggest || []).filter(
                              (item) =>
                                item?.title
                                  ?.toLowerCase()
                                  .includes(value?.toLowerCase()),
                            );

                            setFilteredTitleSuggestions(filtered);
                            setShowTitlePopup(true);
                            setHighlightedTitleIndex(-1);
                          } else {
                            setShowTitlePopup(false);
                          }
                        }}
                        onFocus={() => {
                          if (jobcardTitleSuggest?.length > 0) {
                            setFilteredTitleSuggestions(jobcardTitleSuggest);
                            setShowTitlePopup(true);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();

                            if (
                              highlightedTitleIndex >= 0 &&
                              filteredTitleSuggestions[highlightedTitleIndex]
                            ) {
                              const selected =
                                filteredTitleSuggestions[highlightedTitleIndex];

                              setFormData((prev) => ({
                                ...prev,
                                title: selected.title,
                              }));

                              setShowTitlePopup(false);
                              setHighlightedTitleIndex(-1);
                            } else if (formData.title.trim()) {
                              handleTitleSave(e);

                              const newTitle = { title: formData.title.trim() };

                              setTitleSuggest((prev) => {
                                const exists = prev.some(
                                  (t) =>
                                    t?.title?.toLowerCase() ===
                                    newTitle?.title?.toLowerCase(),
                                );

                                if (exists) return prev;

                                return [newTitle, ...prev];
                              });

                              setShowTitlePopup(false);
                            }
                          } else if (e.key === "ArrowDown") {
                            e.preventDefault();
                            if (filteredTitleSuggestions.length === 0) return;

                            setHighlightedTitleIndex((prev) =>
                              prev < filteredTitleSuggestions.length - 1
                                ? prev + 1
                                : 0,
                            );
                          } else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            if (filteredTitleSuggestions.length === 0) return;

                            setHighlightedTitleIndex((prev) =>
                              prev > 0
                                ? prev - 1
                                : filteredTitleSuggestions.length - 1,
                            );
                          }
                        }}
                      />

                      {/* Suggestions */}
                      {showTitlePopup &&
                        filteredTitleSuggestions?.length > 0 && (
                          <ul
                            className="suggestions-list"
                            ref={titleListRef}
                            style={{
                              maxHeight: "120px",
                              overflowY: "auto",
                            }}
                          >
                            {filteredTitleSuggestions.map(
                              (suggestion, index) => (
                                <li
                                  key={index}
                                  ref={(el) =>
                                    (titleSuggestionRefs.current[index] = el)
                                  }
                                  className={`suggestion-item ${
                                    highlightedTitleIndex === index
                                      ? "highlighted"
                                      : ""
                                  }`}
                                  style={{ cursor: "pointer" }}
                                  onMouseDown={() => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      title: suggestion.title,
                                    }));

                                    setTitleSuggest((prev) => {
                                      const updated = [
                                        suggestion,
                                        ...prev.filter(
                                          (t) => t.title !== suggestion.title,
                                        ),
                                      ];
                                      return updated;
                                    });

                                    setShowTitlePopup(false);
                                  }}
                                >
                                  {suggestion.title}
                                </li>
                              ),
                            )}
                          </ul>
                        )}
                    </div>
                  </div>

                  {/* --- Task Section --- */}
                  <div className="card">
                    <div className="card-body">
                      <div>
                        <div className="mb-3">
                          {/* Header — only show top button if tasks exist */}
                          {tasks?.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center gap-4">
                                <div>Task List</div>{" "}
                                {editDataState?.estimatedCost > 0 && (
                                  <div className="d-flex align-items-center me-2">
                                    <label className="fw-medium me-1 mb-0">
                                      Estimate Cost
                                    </label>
                                    <span className="badge rounded-pill bg-label-fall">
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        editDataState?.estimatedCost || 0,
                                        "INR",
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <button
                                type="button"
                                className="btn btn-label-orange d-flex align-items-center shadow-none"
                                onClick={() => {
                                  setSelectedTask(null);
                                  setTaskModalOpen(true);
                                }}
                              >
                                <AddIcon iClass={"me-1"}/> New
                                Task
                              </button>
                            </div>
                          )}
                        </div>

                        <div className="list-group">
                          {tasks.length === 0 ? (
                            <div className="text-center py-2">
                              <div className="text-muted fst-italic mb-3">
                                No tasks
                              </div>
                              {/* Centered button when no tasks */}
                              <button
                                type="button"
                                className="btn btn-label-orange d-flex align-items-center mx-auto shadow-none"
                                onClick={() => {
                                  setSelectedTask(null);
                                  setTaskModalOpen(true);
                                }}
                              >
                                <AddIcon iClass={"me-1"}/> New
                                Task
                              </button>
                            </div>
                          ) : (
                            tasks
                              .filter((t) => t.status !== "CANCELLED")
                              .map((task, index) => {
                                const isCompleted = task.status === "COMPLETED";

                                return (
                                  <div
                                    key={index}
                                    className={`list-group-item list-group-item-action d-flex align-items-center ${
                                      isCompleted
                                        ? "bg-label-success text-white"
                                        : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectedTask(task);
                                      setTaskModalOpen(true);
                                    }}
                                    onMouseEnter={() => setHoverIndex(index)}
                                    onMouseLeave={() => setHoverIndex(null)}
                                  >
                                    {/* --- Status Icon --- */}
                                    <div
                                      className={`d-flex align-items-center justify-content-center ${
                                        isCompleted
                                          ? "bg-success-custom text-white"
                                          : "bg-label-warning text-dark"
                                      }`}
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        minWidth: "36px",
                                        minHeight: "36px",
                                        textAlign: "center",
                                        fontSize: "16px",
                                        flexShrink: 0,
                                        backgroundColor: isCompleted
                                          ? "#00d959"
                                          : "#ffc107",
                                        color: isCompleted ? "#fff" : "#000",
                                      }}
                                    >
                                      {isCompleted ? (
                                        <CheckLgIcon/>
                                      ) : (
                                        <HourglassSplitIcon/>
                                      )}
                                    </div>

                                    {/* --- Title and Description --- */}
                                    <div className="w-100 ms-3">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="user-info">
                                          <h6 className="mb-1 text-black">
                                            {task?.title || "Untitled"}
                                          </h6>
                                          <small
                                            className="text-muted"
                                            style={{
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "normal",
                                              maxWidth: "380px", // control width
                                            }}
                                          >
                                            {task?.description || ""}
                                          </small>
                                        </div>

                                        {/* --- Right side buttons --- */}
                                        <div className="d-flex align-items-center position-relative">
                                          <span className="text-muted me-2 badge rounded-pill bg-label-fall text-right">
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              task?.amount || 0,
                                              "INR",
                                            )}
                                          </span>

                                          {isCompleted ? (
                                            <div
                                              className="position-relative"
                                              onMouseEnter={() =>
                                                setHoverIndex(index)
                                              }
                                              onMouseLeave={() =>
                                                setHoverIndex(null)
                                              }
                                            >
                                              {hoverIndex === index && (
                                                <>
                                                  {/* Delete Button */}
                                                  <button
                                                    className="btn btn-sm btn-label-danger shadow-none  me-2"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const currentTask =
                                                        tasks[index];
                                                      if (!currentTask?._id)
                                                        return;

                                                      setDeleteData(
                                                        currentTask,
                                                      );
                                                      setDeleteModalOpen(true);
                                                    }}
                                                  >
                                                    <DeleteIcon/>
                                                  </button>

                                                  {/* Undo Button */}
                                                  <button
                                                    className="btn btn-sm btn-outline-secondary shadow-none"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const newStatus =
                                                        task.status ===
                                                        "COMPLETED"
                                                          ? "PENDING"
                                                          : "COMPLETED";
                                                      handleTaskStatusChange(
                                                        task,
                                                        newStatus,
                                                      );
                                                    }}
                                                  >
                                                    <UndoIcon iClass={"fs-15"}/>{" "}
                                                    Undo
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <div
                                              className="position-relative"
                                              onMouseEnter={() =>
                                                setHoverIndex(index)
                                              }
                                              onMouseLeave={() =>
                                                setHoverIndex(null)
                                              }
                                            >
                                              {hoverIndex === index && (
                                                <button
                                                  className="btn btn-sm btn-label-danger shadow-none me-2"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!task?._id) return;
                                                    setDeleteData(task);
                                                    setDeleteModalOpen(true);
                                                  }}
                                                >
                                                  <DeleteIcon/>
                                                </button>
                                              )}
                                              {/* Done Button */}
                                              <button
                                                className="btn btn-sm btn-label-dark shadow-none "
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleTaskStatusChange(
                                                    task,
                                                    "COMPLETED",
                                                  );
                                                }}
                                              >
                                                <CheckIcon iClass={"fs-15"}/>{" "}
                                                Done
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Section */}
                <div
                  className="col-md-4"
                  style={{ maxHeight: "100%", overflowY: "auto" }}
                >
                  <div className="card mb-2">
                    <div className="card-body">
                      <div className="col-lg-12">
                        <div className="card shadow-none border-blue mb-0">
                          {/* Header */}
                          <div className="card-header bg-label-secondary p-2 d-flex justify-content-between align-items-center">
                            {/* LEFT SIDE */}
                            <div className="d-flex align-items-center gap-2">
                              <div className="mb-0 fw-600">Specifications</div>

                              {/* Category Dropdown */}
                              {/* <select
                                className="form-select form-select-sm"
                                style={{ width: "140px" }}
                                value={selectedTemplate || ""}
                                onChange={(e) =>
                                  handleTemplateAttach(e.target.value)
                                }
                              >
                                {/* Default label 
                                <option value="">Select Template</option>

                                {templateList.length > 0 ? (
                                  templateList.map((t) => (
                                    <option key={t._id} value={t._id}>
                                      {t.name}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>No Templates</option>
                                )}
                              </select> */}
                            </div>

                            {/* RIGHT SIDE */}
                            <div>
                              {localEditData?.attributes?.length > 0 && (
                                <button
                                  type="button"
                                  className="btn-label-dark rounded shadow-none border-0"
                                  onClick={() => setAttributesOpen(true)}
                                >
                                  <EditIcon iClass={"me-2 fs-12"}/>
                                  Edit
                                </button>
                              )}
                            </div>
                          </div>

                          {/* Body */}
                          <div className="card-body px-2 py-1">
                            {localEditData?.attributes?.length > 0 ? (
                              localEditData.attributes.map((a, idx) => (
                                <p key={idx} className="my-1 fs-13">
                                  {a.key}:{" "}
                                  <span className="fw-600">{a.value}</span>
                                </p>
                              ))
                            ) : (
                              <div className="text-center">
                                <p className="my-2 text-muted">
                                  No specifications available.
                                </p>

                                <button
                                  type="button"
                                  className="btn btn-outline-secondary shadow-none btn-sm mt-1"
                                  onClick={() => setAttributesOpen(true)}
                                >
                                  <AddIcon iClass={"me-1"}/>
                                  Add Specification
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <div className="card  mb-2">
                      <div className="card-body">
                        <div
                          className="ms-auto position-relative"
                          ref={customerWrapperRef}
                        >
                          <SearchInput
                            searchRef={customerSuggestionsRef}
                            value={customerSearchTerm}
                            onChange={(e) => {
                              handleCustomerSearch(e.target.value);
                              setShowCustomerDropdown(true);
                              setHighlightedIndex(-1);
                            }}
                            onFocus={() => {
                              if (customerSuggestions.length > 0) {
                                setShowCustomerDropdown(true);
                              }
                            }}
                            onSearch={
                              customerSearchTerm.trim()
                                ? () =>
                                    handleCustomerModalOpen(
                                      customerSearchTerm.trim(),
                                    )
                                : null
                            }
                            placeholder="Search customer by name, phone, email, referenceID..."
                            onKeyDown={handleCustomerKeyDown}
                          />
                          {customerSearchTerm &&
                            customerSuggestions.length === 0 && (
                              <ul className="suggestions-list">
                                <li className="suggestion-item text-muted">
                                  No customers data was found
                                </li>
                              </ul>
                            )}
                          {showCustomerDropdown &&
                            customerSuggestions.length > 0 && (
                              <ProductSearchList
                                suggest={customerSuggestions}
                                suggestionRefs={suggestionRefs}
                                handleSelect={handleSelectCustomer}
                                activeIndex={highlightedIndex}
                                type="customer"
                              />
                            )}
                        </div>
                        <div className="col-lg-12 mt-1">
                          <div className="card shadow-none border-blue mb-0">
                            <div className="card-header bg-label-orange p-2 d-flex justify-content-between align-items-center">
                              <div className="mb-0">Customer Info</div>
                              {selectedCustomer && (
                                <div>
                                  <button
                                    type="button"
                                    className="btn-label-orange  rounded shadow-none border-0"
                                    onClick={() =>
                                      openEditModal(selectedCustomer)
                                    }
                                  >
                                    <EditIcon/>
                                  </button>
                                </div>
                              )}
                            </div>
                            <div className="card-body px-2 py-0">
                              {selectedCustomer ? (
                                <>
                                  <p className="my-1 fs-13">
                                    Name :{" "}
                                    <span className="fw-600 fs-14">
                                      {selectedCustomer.name}
                                    </span>
                                  </p>
                                  <p className="my-1 fs-13">
                                    Phone :{" "}
                                    <span className="fw-600 fs-14">
                                      {selectedCustomer.phone}{" "}
                                    </span>
                                  </p>
                                </>
                              ) : (
                                <p className="my-2 text-muted">
                                  No customers has been selected
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card  mb-2">
                    <div className="card-body">
                      {/* Status */}
                      <div className="row mb-3 align-items-center">
                        <label className="form-label col-4 fw-medium">
                          Status
                        </label>
                        <div className="col-8">
                          <select
                            className="form-select"
                            value={formData.status || ""}
                            onChange={handleStatusChange}
                            style={{ cursor: "pointer" }}
                            disabled={formData.status === "CANCELLED"} // 👈 disables dropdown if cancelled
                          >
                            <option value="PENDING">Pending</option>
                            <option value="INPROGRESS">In Progress</option>
                            <option value="READY">Ready</option>
                            <option value="DELIVERED">Delivered</option>
                            <option value="CANCELLED">Cancelled</option>
                          </select>
                        </div>
                      </div>

                      {/* Priority */}
                      <div
                        className="row mb-3 align-items-center b-0"
                        ref={dropdownRef}
                      >
                        <label className="col-4 form-label fw-medium">
                          Priority
                        </label>
                        <div className="col-8">
                          <div className="dropdown">
                            <button
                              className={`btn dropdown-toggle shadow-none w-100 text-start d-flex align-items-center justify-content-between border-0 ${
                                (formData.priority || "") === "LOW"
                                  ? "bg-label-success"
                                  : (formData.priority || "") === "HIGH"
                                    ? "bg-label-danger"
                                    : "bg-label-warning"
                              }`}
                              onClick={() => setOpen(!open)}
                            >
                              <span className="d-flex align-items-center">
                                {selectedOption && (
                                  <span className="me-2">
                                    {selectedOption.icon}
                                  </span>
                                )}
                                {selectedOption
                                  ? selectedOption.label
                                  : "Select Priority"}
                              </span>
                            </button>

                            {open && (
                              <ul className="dropdown-menu show">
                                {options.map((opt) => (
                                  <li
                                    key={opt.value}
                                    className="dropdown-item"
                                    onClick={async () => {
                                      const newValue = opt.value;
                                      handleChange("priority", newValue);
                                      handleBlurUpdate("priority", newValue);
                                      setOpen(false);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <span className="me-2">{opt.icon}</span>
                                    {opt.label}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Due Date */}
                      <div className="row align-items-center">
                        <label className="col-4 form-label fw-medium">
                          Due Date
                        </label>

                        <div className="col-8">
                          <div className="input-group">
                            {/* Calendar Icon */}
                            <span className="input-group-text">
                              <CalendarIcon/>
                            </span>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                open={openDatePicker}
                                onOpen={() => setOpenDatePicker(true)}
                                onClose={() => setOpenDatePicker(false)}
                                disableOpenPicker
                                value={
                                  formData.dueDate
                                    ? dayjs(formData.dueDate)
                                    : null
                                }
                                format="DD MMM YYYY"
                                emptyLabel="Select Due Date" // ✅ THIS WORKS
                                onChange={(newValue) => {
                                  if (!newValue) {
                                    handleChange("dueDate", null);
                                    return;
                                  }

                                  const dateObj = newValue.toDate();
                                  handleChange("dueDate", dateObj);
                                  handleBlurUpdate(
                                    "dueDate",
                                    dateObj.toISOString(),
                                  );
                                }}
                                slotProps={{
                                  popper: {
                                    disablePortal: true,
                                    sx: { zIndex: 9999 },
                                  },
                                  textField: {
                                    size: "small",
                                    className: "form-control",
                                    onClick: () => setOpenDatePicker(true),
                                    inputProps: { readOnly: true },
                                    onKeyDown: (e) => e.preventDefault(),
                                    sx: {
                                      "& .MuiInputBase-input": {
                                        cursor: "pointer",
                                      },
                                    },
                                  },
                                  openPickerButton: {
                                    sx: { display: "none" },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card ">
                    <div className="card-body">
                      {/* Advance Paid */}
                      <div className="mb-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="mb-0 fw-medium">Advance</div>
                          <div>
                            <button
                              type="button"
                              className="btn btn-sm btn-label-jobcard shadow-none text-right"
                              onClick={() => setAdvanceModalOpen(true)}
                            >
                              <AddIcon/> Advance
                            </button>
                          </div>
                        </div>
                        <div className="">
                          <div className=" rounded  bg-label-retro">
                            <div
                              className="row align-items-center"
                              style={{ cursor: "pointer" }}
                              onClick={async () => {
                                await fetchAdvanceHistory();
                                setHistoryModalOpen(true);
                              }}
                            >
                              <div className="col-6">
                                <label
                                  className="form-label mb-0 px-2 py-1 text-center mb-1"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  Total Paid
                                </label>
                              </div>
                              <div className="col-5 me-1">
                                <span className="badge rounded-pill bg-label-fall text-right px-2 py-1">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    totalAdvancePaid || 0,
                                    "INR",
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                type="button ms-4"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <CloseIcon iClass={"fs-15"}/> Close
              </button>
              <button
                className="btn text-right"
                style={{
                  background: "#ffab1d",
                  color: "#000",
                  border: "none",
                }}
                onClick={onClose}
              >
                <CheckIcon/> Done
              </button>

              <div className="btn-group text-right align-items-center">
                {print ? (
                  <button className="btn btn-warning  pb-0" disabled>
                    <CircularProgress size={18} className="text-black" />
                  </button>
                ) : (
                  <>
                    {/* Dropdown toggle */}
                    <button
                      type="button"
                      className="btn bg-label-animal shadow-none dropdown-toggle dropdown-toggle-split"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ borderRight: "2px solid #fff" }}
                    />

                    {/* Print button */}
                    <button
                      onClick={() => {
                        // Determine type based on selected size
                        let type;
                        if (selectedSize === "2inch") type = "receipt";
                        else if (selectedSize === "A4") type = "jobcard-a4";
                        else if (selectedSize === "Half A4")
                          type = "jobcard-half";
                        handlePrint(type, jobcardId || editData?._id);
                      }}
                      className="btn bg-label-animal shadow-none  rounded-end"
                      id="printreceiptbtn"
                    >
                      <PrinterIcon iClass={"fs-15"}/> Print{" "}
                      {selectedSize}
                    </button>

                    {/* Dropdown menu */}
                    <ul className="dropdown-menu dropdown-menu-end">
                      {["2inch", "A4", "Half A4"].map((size) => (
                        <li key={size}>
                          <button
                            className={`dropdown-item ${
                              selectedSize === size ? "active" : ""
                            }`}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size === "2inch" ? "2-inch Receipt" : size}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {taskModalOpen && (
        <TaskModal
          jobcardId={jobcardId || editDataState?._id}
          ensureJobcard={ensureJobcard}
          titleSuggest={titleSuggest}
          localTitleSuggest={localTitleSuggest}
          setLocalTitleSuggest={setLocalTitleSuggest}
          editTask={selectedTask}
          onClose={() => {
            setTaskModalOpen(false);
            setSelectedTask(null);
          }}
          onTaskSaved={(updatedJobcard) => {
            if (updatedJobcard) {
              const tasks = updatedJobcard.task || [];
              const taskCount = tasks.filter(
                (t) => t.status?.toUpperCase() !== "CANCELLED",
              ).length;
              const completedCount = tasks.filter(
                (t) => t.status?.toUpperCase() === "COMPLETED",
              ).length;

              setTasks(tasks);

              setFormData((prev) => ({
                ...prev,
                status: updatedJobcard.status,
                estimatedCost: updatedJobcard.estimatedCost,
              }));

              setEditDataState((prev) => ({
                ...prev,
                task: tasks,
                estimatedCost: updatedJobcard.estimatedCost,
                status: updatedJobcard.status,
              }));

              if (typeof onJobcardUpdate === "function") {
                onJobcardUpdate(updatedJobcard);
                handleJobcardFieldUpdate(updatedJobcard._id, {
                  task: tasks,
                  taskCount: taskCount,
                  completedCount: completedCount,
                });
              }
            }
          }}
        />
      )}

      {advanceModalOpen && (
        <AdvanceModal
          jobcardId={jobcardId || editData?._id}
          onClose={() => setAdvanceModalOpen(false)}
          onAdvanceAdded={(newAmount, updatedTotal) => {
            const numericAmount = Number(newAmount) || 0;

            // Update local advance history
            setAdvanceHistory((prev) => [...prev, numericAmount]);

            // Update total advance state
            setTotalAdvancePaid(updatedTotal);

            // Optional: update formData if needed
            setFormData((prev) => ({
              ...prev,
              advancePaid: updatedTotal,
            }));
            if (typeof onJobcardUpdate === "function") {
              handleJobcardFieldUpdate(editData?._id, {
                totalAdvancePaid: updatedTotal,
              });
            }
          }}
        />
      )}

      {historyModalOpen && (
        <AdvanceHistoryModal
          history={advanceHistory}
          loading={loadingAdvanceHistory}
          onClose={() => setHistoryModalOpen(false)}
        />
      )}

      <AddCustomer
        isActive={isActive}
        isOpen={isCustomerModalOpen}
        onClose={handleCustomerModalClose}
        onData={isCustomerData}
        onAdd={handleCustomerAdd}
        isBtnLoading={isBtnLoading}
        groupName={groupName}
        onNewGroupsIn={handleCustomerGroupAdd}
        newGroup={newGroupName}
        resetAll={true}
        error={errors}
        setErrors={setErrors}
        numberSuggest={numberSuggest}
        addNewCustomNumber={addNewCustomNumber}
      />

      {isEditModalOpen && (
        <EditCutomer
          isActive={isActive}
          editData={isEditData}
          onClose={closeEditModal}
          onEdit={handleUpdte}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          groupId={selectedCustomer?.groupid}
          onNewGroupsIn={handleCustomerGroupAdd}
          resetAll={true}
          newGroup={newGroupName}
          error={errors}
          setErrors={setErrors}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          onClose={() => setDeleteModalOpen(false)}
          onConfirm={handleDeleteTask}
          isLable={"Task " + (isDeleteData?.title || "")}
          isBtnLoading={isBtnLoading}
        />
      )}

      {attributesopen && (
        <SpecificationsModal
          onClose={() => setAttributesOpen(false)}
          jobcardId={jobcardId || editData?._id}
          editData={editDataState}
          ensureJobcard={ensureJobcard}
          attributeSuggest={attributeSuggest}
          onAttributesChange={handleAttributesUpdate}
        />
      )}

      {showCancelConfirm && (
        <CancelConfirmation
          onConfirm={confirmCancellation}
          onClose={() => setShowCancelConfirm(false)}
        />
      )}
    </div>
  );
};

export default EditJobcard;
